<template>
  <div class="user-management-close-google main-second-bg">
    <p class="user-management-child-header main-cl a-3-bd">{{ $t("personal.closeGoogle.title") }}</p>
    <div class="user-management-center">
      <div class="management-center">
        <c-inputLine
          name="smsCode"
          maxLength="6"
          inputType="text"
          :promptText="promptText2"
          :errorHave="true"
          :errorText="errorText2"
          :errorFlag="checkErrorFlag2"
          marginTop="0px"
          :value="checkValue2"
          @onchanges="inputChanges"
          newStyleFormat
        >
          <!-- 获取验证码 -->
          <c-getCode
            name="smsCode"
            @click="getCodeClick"
            :autoStart="false"
            buttonName="loginGetcodeBtn"
          />
        </c-inputLine>
        <c-inputLine
          name="googleCode"
          maxLength="6"
          inputType="text"
          :promptText="promptText1"
          :errorHave="true"
          :errorText="errorText1"
          :errorFlag="checkErrorFlag1"
          marginTop="0px"
          :value="checkValue1"
          @onchanges="inputChanges"
          newStyleFormat
        >
        </c-inputLine>
        <c-button
          type="solid"
          :big="true"
          :loading="loading"
          className=""
          paddingW="0px"
          :disabled="disabled"
          marginTop="18px"
          height="40px"
          width="100%"
          @click="btnLink"
          >{{ $t("personal.tool.submit") }}</c-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CloseGoogle',
  watch: {
    sendSmsCode(sendSmsCode) {
      if (sendSmsCode !== null) {
        if (sendSmsCode.text === 'success') {
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'success' });
          this.$store.dispatch('resetType');
        } else {
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    closeGoogleVerify(closeGoogleVerify) {
      if (closeGoogleVerify !== null) {
        this.loading = false;
        if (closeGoogleVerify.text === 'success') {
          this.$bus.$emit('tip', { text: closeGoogleVerify.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.$router.push('/personal/userManagement');
        } else {
          this.$bus.$emit('tip', { text: closeGoogleVerify.msg, type: 'error' });
          this.$store.dispatch('resetType');
          if (closeGoogleVerify.code !== '10009') {
            this.$bus.$emit('getCode-clear', 'smsCode');
          }
        }
      }
    },
  },
  computed: {
    sendSmsCode() {
      return this.$store.state.personal.sendSmsCode;
    },
    closeGoogleVerify() {
      return this.$store.state.personal.closeGoogleVerify;
    },
  },
  data() {
    return {
      loading: false,
      checkValue1: '',
      checkValue2: '',
      promptText1: this.$t('personal.label.googleCodeText'),
      promptText2: this.$t('personal.label.smsCodeText'),
      errorText1: this.$t('personal.prompt.errorCode'),
      errorText2: this.$t('personal.prompt.errorCode'),
      checkErrorFlag1: false,
      checkErrorFlag2: false,
      disabled: true,
    };
  },
  methods: {
    codeFlag(val) {
      return this.$store.state.regExp.verification.test(val);
    },
    getCodeClick(name) {
      if (name === 'smsCode') {
        this.$bus.$emit('getCode-start', 'smsCode');
        const info = { operationType: 26 };
        this.$store.dispatch('sendSmsCode', info);
      }
    },
    inputChanges(value, name) {
      if (name === 'googleCode') {
        this.checkValue1 = value;
        if (this.codeFlag(value)) {
          this.checkErrorFlag1 = false;
        } else {
          this.checkErrorFlag1 = true;
        }
      } else {
        this.checkValue2 = value;
        if (this.codeFlag(value)) {
          this.checkErrorFlag2 = false;
        } else {
          this.checkErrorFlag2 = true;
        }
      }
      if (this.checkValue1 && this.checkValue2 && !this.checkErrorFlag1 && !this.checkErrorFlag2) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    btnLink() {
      this.loading = true;
      const info = {
        googleCode: this.checkValue1,
        smsValidCode: this.checkValue2,
      };
      this.$store.dispatch('closeGoogleVerify', info);
    },
  },
};
</script>
<style lang="scss" scoped>
.user-management-close-google {
  width: 100%;
  min-height: 800px;
  border-radius: 6px;

  .user-management-child-header {
    font-size: 14px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }
  .management-center {
    width: 447px;
    margin: 70px auto;
  }
}
</style>
